import api from '@/api'
import {
  SET_CLIENT_AD_LIST,
  SET_CLIENT_AD_LIST_PAGE_SIZE,
  SET_CLIENT_AD_LIST_TOTAL,
  SET_CLIENT_AD_PAGE_COUNT,
} from './mutation-types'
const state = {
  pageSize: 20,
  pageCount: 0,
  total: 0,
  clientAdList: [],
}
const mutations = {
  [SET_CLIENT_AD_LIST](state, payload) {
    state.clientAdList = payload
  },
  [SET_CLIENT_AD_PAGE_COUNT](state, payload) {
    state.pageCount = payload
  },
  [SET_CLIENT_AD_LIST_PAGE_SIZE](state, payload) {
    state.pageSize = payload
  },
  [SET_CLIENT_AD_LIST_TOTAL](state, payload) {
    state.total = payload
  },
}
const actions = {
  async getClientAdList({ state, commit }, payload) {
    let params = {
      pageSize: payload.pageSize,
      pageNum: payload.pageNum,
      advertisingTitle: payload.advertisingTitle,
      startTime: payload.startTime,
      endTime: payload.endTime,
    }
    try {
      const {
        data: { items, pageCount, total },
      } = await api.deployApi.getPicAdvertiseList(params)
      commit(SET_CLIENT_AD_LIST, items)
      commit(SET_CLIENT_AD_PAGE_COUNT, pageCount)
      commit(SET_CLIENT_AD_LIST_TOTAL, total)
    } catch (error) {
      commit(SET_CLIENT_AD_LIST, [])
      commit(SET_CLIENT_AD_PAGE_COUNT, 0)
    }
  },
  refreshClientAdList({ dispatch }) {
    dispatch('getClientAdList', { pageNum: 1, pageSize: state.pageSize })
  },
  updatePageSize({ commit }, payload) {
    commit(SET_CLIENT_AD_LIST_PAGE_SIZE, payload)
  },
  // 新增
  async addPicAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.addPicAdvertise(payload)
    dispatch('refreshClientAdList')
    return result
  },
  // 编辑
  async editPicAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.editPicAdvertise(payload)
    dispatch('refreshClientAdList')
    return result
  },
  // 删除
  async deletePicAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.deletePicAdvertise(payload)
    dispatch('refreshClientAdList')
    return result
  },
  async exportPicAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.exportPicAdvertise(payload)
    dispatch('refreshClientAdList')
    return result
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
